
    import './styles.scoped.css';
    export default {
  "segment__path": "awsui_segment__path_1edmh_dbsxs_101",
  "segment": "awsui_segment_1edmh_dbsxs_101",
  "segment__hover": "awsui_segment__hover_1edmh_dbsxs_128",
  "label": "awsui_label_1edmh_dbsxs_142",
  "root": "awsui_root_1edmh_dbsxs_160",
  "content": "awsui_content_1edmh_dbsxs_164",
  "content--small": "awsui_content--small_1edmh_dbsxs_164",
  "content--fit-height": "awsui_content--fit-height_1edmh_dbsxs_167",
  "content--without-labels": "awsui_content--without-labels_1edmh_dbsxs_170",
  "content--medium": "awsui_content--medium_1edmh_dbsxs_176",
  "content--large": "awsui_content--large_1edmh_dbsxs_188",
  "status-container": "awsui_status-container_1edmh_dbsxs_205",
  "chart-container": "awsui_chart-container_1edmh_dbsxs_209",
  "chart-container--fit-height": "awsui_chart-container--fit-height_1edmh_dbsxs_213",
  "chart-container-chart-plot": "awsui_chart-container-chart-plot_1edmh_dbsxs_218",
  "chart-container-chart-plot--fit-height": "awsui_chart-container-chart-plot--fit-height_1edmh_dbsxs_221",
  "inner-content": "awsui_inner-content_1edmh_dbsxs_227",
  "segment__highlight": "awsui_segment__highlight_1edmh_dbsxs_238",
  "segment--dimmed": "awsui_segment--dimmed_1edmh_dbsxs_253",
  "segment--highlighted": "awsui_segment--highlighted_1edmh_dbsxs_256",
  "label--dimmed": "awsui_label--dimmed_1edmh_dbsxs_273",
  "label--align-right": "awsui_label--align-right_1edmh_dbsxs_276",
  "label-text": "awsui_label-text_1edmh_dbsxs_284",
  "label__description": "awsui_label__description_1edmh_dbsxs_292",
  "label-line": "awsui_label-line_1edmh_dbsxs_299",
  "label--highlighted": "awsui_label--highlighted_1edmh_dbsxs_303",
  "popover-header": "awsui_popover-header_1edmh_dbsxs_307"
};
  